var passiveSupported = false

try {
  var options = Object.defineProperty({}, 'passive', {
    get: function () {
      passiveSupported = true
    }
  })
  window.addEventListener('test', null, options)
} catch (err) {}

export default passiveSupported



// WEBPACK FOOTER //
// ./node_modules/_vux@2.11.1@vux/src/libs/passive_supported.js